import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-commentInput-control-label-view, [app-commentInput-control-label-view]',
  templateUrl: './commentInput-control-label-view.component.html',
  styleUrls: ['./commentInput-control-label-view.component.scss']
})
export class CommentInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
